import React from 'react'
import backgroundImg from "../assets/backgroundImg.png"
import { HiOutlineArrowTopRightOnSquare } from "react-icons/hi2";
import { LuArrowRight, LuGift, LuHandshake, LuLock, LuPackage, LuRefreshCw } from 'react-icons/lu';
import { PrimaryLink } from '../components/Button';
import Faq from "react-faq-component";
import aboutImage from "../assets/aboutImages/aboutImage1.png";
import abstract from "../assets/abstract.svg";
import deliver from "../assets/deliver.svg";
import order from "../assets/order.svg";
import { BrandCarousel } from '../components/BrandCarousel';
import { TestimonialCarousel } from '../components/TestimonialCarousel';



export const Home = () => {

  const images = [abstract, deliver, order];
  const titles = ["Build", "Choose", "Deliver"];
  const text = [
    "Select Your Desired Parts from your case to your processor",
    "Do You want it Prebuilt or Do You want To Build it Yourself?",
    "Sit back as we handle the shipping to you",
  ];
  
  const data = {
    rows: [
        {
          title: <p className='font-bold'>What services do you offer?</p>,
          content: <p>We provide personalized IT consultations, computer repair and upgrade services, and network setup and support.
            We also offer custom-build PCs where you can choose from our pre-built selections or customize a PC based on your needs and budget.</p>,
        },
        { title: <p className='font-bold'>How can I contact you?</p>,
          content: <p>You can reach us via our About Us page, where you'll find our phone numbers, our Facebook page, and a contact form.</p>,
        },
        {
          title: <p className='font-bold'>What are your operating hours?</p>,
          content: <p>Our centers are open Monday to Saturday from 8 AM to 6 PM (PST)</p>,
        },
    ],
  };

  const styles = {
    bgColor: 'white',
    titleTextColor: "black",
    rowTitleColor: "black",
  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    tabFocus: true
  };

  const offeringIcons = [
    <LuPackage size={24}/>,
    <LuRefreshCw size={24}/>,
    <LuGift size={24}/>,
    <LuLock size={24}/>,
    <LuHandshake size={24}/>
  ]
  
  const offeringTitle = [
    "Free Shipping",
    "Warranty Replacement",
    "Special Gifts",
    "Secured Payemnts",
    "Support 24/7",
  ]
  
  const offeringText = [
    "For All Orders Over ₱5,000",
    "For Item Defects",
    "On Laptop or Computer Repairs",
    "Payment Cards Accepted",
    "Contact Us Anytime",
  ]

  return (
    <div className="h-fit w-full overflow-hidden">
      {/* Welcome Hero Section */}
      <div 
        className="flex h-screen w-full relative items-center justify-between overflow-hidden px-8 md:px-16 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(254, 243, 199, 0.8), rgba(255, 255, 255, 0.85), rgba(254, 243, 199, 0.8)), url(${backgroundImg})`,
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="flex flex-col w-full md:w-1/2 gap-y-6 z-10">
          <div className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-gray-900">
            Empower Your World with <span className="text-amber-600">Jasper Kissa</span>
          </div>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-xl">
            Where technology meets expertise—unlock the potential of your devices with our premium products and unmatched repair services.
          </p>

          <div className="flex flex-col md:flex-row gap-x-4 gap-y-4 items-start md:items-center mt-4 text-white">
            <PrimaryLink 
            icon={undefined}
            route="/products"
            label="Browse Categories"
            />
            <PrimaryLink 
            route="/about"
            label="Learn More"
            icon={<HiOutlineArrowTopRightOnSquare />}
            />
          </div>
        </div>
      </div>

      {/* Mission & Values - Offerings */}
      <div className="w-full bg-gradient-to-b from-white to-slate-50 py-20 px-8 md:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="text-amber-600 text-sm font-bold uppercase tracking-widest mb-4">Our Commitment</div>
            <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Mission & Values
            </div>
            <p className="text-lg text-gray-700 max-w-2xl mx-auto leading-relaxed">
              Jasper Kissa aims to provide unparalleled service by focusing on our customers' needs and offer services with honesty, transparency, and a passion for technology
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 md:gap-8">
            {offeringIcons.map((icon, index) => (
              <div 
              key={`offering-${index}`}
              className="group bg-white rounded-lg p-8 text-center hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-amber-200">
                <div className="flex justify-center mb-4 text-amber-600 group-hover:scale-110 transition-transform duration-300">
                  {icon}
                </div>
                <div className="font-bold text-lg text-gray-900 mb-2">{offeringTitle[index]}</div>
                <p className="text-gray-600 text-sm">{offeringText[index]}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* IT Services Section */}
      <div className="w-full bg-white py-20 px-8 md:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="text-amber-600 text-sm font-bold uppercase tracking-widest mb-4">Expert Solutions</div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Comprehensive IT Services
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
              At Jasper Kissa Computer Center, we offer a range of expert IT services designed to meet your needs. From personalized consultations to reliable network support, our team is here to help you succeed.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl p-8 border border-amber-100 hover:shadow-xl transition-shadow duration-300">
              <div className="text-amber-600 text-3xl mb-4">💻</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">IT Consultations</h3>
              <p className="text-gray-700 leading-relaxed">Tailored advice to enhance your technology efficiency and productivity. Our experts provide strategic guidance for your business needs.</p>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl p-8 border border-amber-100 hover:shadow-xl transition-shadow duration-300">
              <div className="text-amber-600 text-3xl mb-4">🔧</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Repair Services</h3>
              <p className="text-gray-700 leading-relaxed">Fast and reliable solutions for all your computer issues. Get your devices running smoothly with our professional technicians.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Create Your Own PC */}
      <div className="w-full bg-gradient-to-b from-slate-50 to-white py-20 px-8 md:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <div className="text-amber-600 text-sm font-bold uppercase tracking-widest mb-4">Customization Options</div>
            <h2 className='text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6'>Build Your Dream PC in 3 Steps</h2>
            <p className='text-lg text-gray-700 max-w-2xl mx-auto'>Customize your own or choose from our high-performance pre-built rigs with our simple and intuitive process.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-16">
            {images.map((image, index) => (
              <div 
              key={`step-${index}`}
              className="relative group">
                <div className="absolute -left-4 -top-4 w-10 h-10 bg-amber-600 text-white rounded-full flex items-center justify-center font-bold text-lg">0{index + 1}</div>
                <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 p-8 flex flex-col items-center text-center h-full">
                  <img src={image} alt={titles[index]} className='w-32 h-32 object-contain mb-6'/>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{titles[index]}</h3>
                  <p className='text-gray-700 leading-relaxed flex-grow'>{text[index]}</p>
                  {index < 2 && <div className="hidden md:flex absolute -right-8 top-1/2 transform -translate-y-1/2"><LuArrowRight size={32} className="text-amber-200" /></div>}
                </div>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-amber-50 to-yellow-50 rounded-xl border border-amber-200 p-12 text-center">
            <p className='text-xl md:text-2xl font-bold text-gray-900 mb-2'>Ready to Build Your Perfect PC?</p>
            <p className='text-gray-700 mb-6'>Let our experts help you create the perfect system for your needs.</p>
            <PrimaryLink
            route="/under-construction"
            label="Get Started"
            icon={<LuArrowRight/>}
            />
          </div>
        </div>
      </div>

      {/* Why Jasper Kissa? */}
      <div className="w-full bg-gradient-to-r from-slate-100 to-slate-50 py-20 px-8 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              {/* TODO: Make image widget change to other images after a delay */}
              <img src={aboutImage} alt="aboutImage" className='w-full rounded-xl shadow-lg border border-gray-200'/>
            </div>
            <div className="flex flex-col gap-6">
              <div>
                <div className="text-amber-600 text-sm font-bold uppercase tracking-widest mb-3">Why Choose Us</div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Your Trusted Partner in Tech Excellence</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">From providing you with high-performance PC parts to expert repairs and tailored IT solutions, Jasper Kissa Computer Center is here to power your digital journey.</p>
              
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 bg-amber-600 rounded-full flex items-center justify-center mt-1"><span className="text-white text-sm font-bold">✓</span></div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Expert Technicians</h4>
                    <p className="text-gray-700">Certified professionals with years of industry experience</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 bg-amber-600 rounded-full flex items-center justify-center mt-1"><span className="text-white text-sm font-bold">✓</span></div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Quality Assurance</h4>
                    <p className="text-gray-700">All products and services backed by comprehensive warranties</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 bg-amber-600 rounded-full flex items-center justify-center mt-1"><span className="text-white text-sm font-bold">✓</span></div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Customer First</h4>
                    <p className="text-gray-700">Dedicated support and transparent pricing</p>
                  </div>
                </div>
              </div>
              
              <PrimaryLink 
              route="/about"
              label="Learn More About Us"
              icon={<HiOutlineArrowTopRightOnSquare />}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Brand Carousel */}
      <BrandCarousel />

      {/* Testimonials */}
      <TestimonialCarousel />

      {/* TODO: Add Testimonials Section */}

      {/* FAQs */}
      <div className="w-full bg-white py-20 px-8 md:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <div className="text-amber-600 text-sm font-bold uppercase tracking-widest mb-4">Support</div>
            <h2 className='font-bold text-3xl md:text-4xl lg:text-5xl text-center text-gray-900 mb-6'>Frequently Asked Questions</h2>
            <p className='text-lg text-gray-700 max-w-2xl mx-auto'>Find answers to common questions about our products and services</p>
          </div>
          <div className="bg-slate-50 rounded-xl p-8 md:p-12 border border-gray-200">
            <Faq
              data={data}
              styles={styles}
              config={config}
            />
          </div>
        </div>
      </div>
      {/* Need More Help? */}

    </div>
  )
}